import { info } from "sass-embedded";

export default {
  postdoc: {
    title: "博士后分站",
    content:
      "上海超导体研究所为超导材料与应用领域的优秀研究人员提供博士后岗位，欢迎有志之士加入我们的团队。",
    menuTitle: "博士后分站",
    accordionTitle: "博士后分站",
    accordionContent: "探索前沿超导技术，成就科研梦想。",
    leftPanel: {
      title: "为何要加入我们？",
      paragraph1: "我们在全球范围内寻找顶尖精英人才。",
      paragraph2:
        "只要你敢想敢做，超导就是你实现梦想的舞台，在这里你可以尽情彰显个性，释放激情。",
      paragraph3: "只要你是牛人，只要你对梦想有所执着，超导就是你的归属。",
      paragraph4: "邮箱（招聘）：hr{'@'}shsctec.com",
    },

    jobs: {
      doc: {
        title: "博士后",
        details: `岗位职责：
---通过物理或化学沉积技术实现功能薄膜（金属、金属氧化物等）的生长和调控，并进行相关显微结构和物理性质的表征。

---任职要求：
---1. 身体健康，责任心强，具有良好的团队合作意识；

---2. 有操作薄膜生长设备（例如电子束蒸镀、脉冲激光沉积，溶胶凝胶等）的相关经验；

---3. 掌握薄膜外延原理，具有一定薄膜表征和物理性质测试经验；

---4. 博士或博士后期间的研究方向直接与薄膜材料有关者优先考虑；

---5. 具有较强的中、英文书面理解和表达能力`,
      },
    },
  },
  recruit: {
    menuTitle: "加入我们",
    accordionTitle: "招聘",
    accordionContent: "寻找顶尖精英人才，共创超导未来。",

    leftPanel: {
      title: "为何要加入我们？",
      paragraph1: "我们在全球范围内寻找顶尖精英人才。",
      paragraph2:
        "只要你敢想敢做，超导就是你实现梦想的舞台，在这里你可以尽情彰显个性，释放激情。",
      paragraph3: "只要你是牛人，只要你对梦想有所执着，超导就是你的归属。",
      paragraph4: "邮箱（招聘）：hr{'@'}shsctec.com",
    },

    jobs: {

      salesSpecialist: {
        title: "销售工程师",
        details: `岗位职责： 
 ---1、深度解读行业政策与市场趋势，精准匹配客户需求与公司核心优势，协同（跨）部门团队优化标书核心内容，打造具有市场竞争力的投标方案。 
 ---2、聚焦行业内重点客户机潜在战略合作伙伴，建立并维护深层次、长期稳定的合作关系。 
 ---3、快速响应客户在技术、产品及服务方面的个性化需求，高效处理各类紧急情况，以专业服务显著提升客户满意度与忠诚度，助力公司构建优质客户生态圈。 
 ---4、独立掌控销售全流程，包括前期客户接洽、需求分析、方案制定，到中期商务谈判、合同签订，再到后期订单执行跟踪，确保每个环节高效推进。 
 ---5、基于对超导行业及相关应用领域的深入研究，制定前瞻性的客户开发战略与计划；通过参与行业展会、开展精准市场调研等多种渠道，积极挖掘潜在战略客户。 
 ---6、主动拜访潜在客户，深入了解其技术需求与业务规划，精准推荐公司二代高温超导带材的技术优势与应用价值，促成高质量合作意向。 
 ---任职要求： 
 ---1、本科及以上学历，材料学、物理学等相关专业优先。 
 ---2、具备二代高温超导带材及相关领域知识者优先。 
 ---3、具备出色的沟通技巧与高端商务谈判能力，能有效与各类客户进行深度交流并达成合作。 
 ---4、拥有优秀的问题解决能力，能独立应对销售过程中的各种复杂情况。对销售工作充满热情，积极主动，具有强烈的目标感与执行力。 
 ---5、具备战略眼光与高度，能从公司长远发展角度思考问题，有清晰的市场洞察力与前瞻性，能为公司销售战略与市场布局提供有价值的想法与建议。 
 ---6、具备良好的团队协作精神，能与部门负责人及其他团队成员紧密配合，共同完成公司销售目标。`,
      },
      testEngineer: {
        title: "测试工程师（研发岗）",
        details: `岗位职责：
---1.负责对超导带材，超导线圈、超导接头进行综合性能测试分析；
---2.对材料进行性能测试和分析，以确保材料能够满足工业应用的需求；
---3.跟踪调研各科研单位及企业对材料的应用情况；
---4.熟练掌握负责各检测设备和表征设备的操作；
---5.负责高温超导材料性能表征与优化；
---任职资格
---1.物理、化学、材料、电气等相关专业，电气优先；
---2.动手能力强，有超导材料相关工作经验者优先考虑 ；
---3.具有较强的观察能力和分析能力，熟悉各类测试设备和数据处理软件；
---4.工作认真负责、严谨细致、有良好的团队意识和沟通能力。`,
      },
//       postProcessor: {
//         title: "后处理技术员",
//         details: `岗位职责：
// ---1.负责带材分切或封装的生产任务及设备日常保养；
// ---2.负责包裹带及银带的点检及记录工作；
// ---3.及时上报生产过程异常，并能发现问题和解决问题；
// ---4.协助主管领导进行带材后处理过程中的统计工作。
// ---任职要求：
// ---1.全日制大专及以上学历；
// ---2.拥有较高的思想觉悟，过硬的综合身体素质；
// ---3.拥有严谨的工作态度，有良好的团队意识和沟通能力，能承受一定的工作压力；
// ---4.能吃苦耐劳，接受加班工作。`,
//       },
//       inspector: {
//         title: "质检员",
//         details: `岗位职责：
// ---1.负责AFM、XRD、台阶仪、光学显微镜等表征设备
// ---2.负责超导带材临界电流测试、电阻、应力测试等带材性能表征设备
// ---3.负责货品入厂、出厂检测、不合格品处理等ISO体系中的质检任务
// ---4.负责一定的检测、应用设备维护工作

// ---任职要求：
// ---1.物理、化学、材料、电气、电子、自动化等相关专业
// ---2.动手能力强，有质量管理经验者优先考虑
// ---3.具有较强的观察能力和分析能力，熟悉各类测试设备和数据处理软件
// ---4.工作认真负责、严谨细致、有良好的团队意识和沟通能力`,
//       },
//       processEngineer: {
//         title: "工艺工程师",
//         details: `岗位职责：
// ---1.负责定制本工艺段的工艺调试计划，生产过程中出现的异常问题解决，及时制定解决办法；
// ---2.对产品结果跟进，核对生产工艺，对生产现场进行检查，确认生产过程无误；
// ---3.能够积极阅读文章，整理文献内容，对现有工艺进行优化升级；
// ---4.制定工艺文件，新项目引入工作跟进等。
// ---任职要求：
// ---1.硕士及以上学历，理工科背景；
// ---2.2年以上工作经验；
// ---3、较高的思想觉悟，过硬的综合身体素质，服从领导安排；
// ---4、工作态度诚恳，可以认真学习新的知识；
// ---5、可以接受加班；
// ---6、有相关真空镀膜工作经验的人员优先。`,
//       },
//       qualityEngineer: {
//         title: "质量工程师",
//         details: `岗位职责：
// ---1、负责现场检验产品质量情况；
// ---2、负责生产过程中的产品缺陷及质量问题总结归纳；
// ---3、安排并设计相应的实验工作，印证质量问题，并寻找解决方案；
// ---4、对已有产品相关性能指标进行提炼，制定产品质量规范；
// ---5、配合完成质量体系相关工作，完成年度计划月度计划等公司内部文件撰写；
// ---6、完成国家标准比对测试、专利撰写、国内项目相关技术文件撰写等工作。
// ---任职要求：
// ---1、研究生及以上学历，机械、电器、材料等相关工科专业；
// ---2、3年以上相关工作经验；
// ---3、具有独立解决问题的能力，愿意努力学习新事物并拓展自己的知识面；
// ---4、工作认真负责，有良好的团队意识和沟通能力；
// ---5、有国家项目申报与结题经验者，有质量体系工作经验者优先。`,
//       },
//       mechanicalDesigner: {
//         title: "机械设计工程师",
//         details: `岗位职责：
// ---1.测绘原有设备结构；
// ---2.根据生产要求设计新生产的设备，并装配调试；
// ---3.对现有设备进行技术改造；
// ---4.设计超导应用相关工装与结构。
// ---任职要求：
// ---1.熟练使用Solidworks、CAD等机械制图软件；
// ---2.具备一定程度的材料应用、热处理、表面处理及公差配合理论基础；
// ---3.有独立设计大型机械设备的经验，能将设计的三位模型转化为委外加工图纸及出BOOM表；
// ---4.工作认真负责，严谨细致，有良好的团队意识和沟通能力；
// ---5.有真空镀膜腔体或卷对卷设备设计经验者优先考虑。`,
//       },
      rdEngineer: {
        title: "研发工程师（研发岗）",
        details: `岗位职责：
---1.根据研发部门的研发计划，设计和落实具体实验方案；
---2.负责真空镀膜生产线（洁净车间）的制程异常分析，提出并落实解决方案；
---3.负责研发新制程工艺与新材料，提升超导带材产品的性能与良率；
---4.协助部门同事共同推进相关研发工作；
---5.完成领导安排的其他研发工作。
---任职资格：
---1.硕士及以上学历，材料类、物理类等相关专业优先；
---2.具有超导材料研究、薄膜材料制备或真空镀膜相关经验者优先；
---3.长期稳定，热爱研发工作，能按照部门的研发计划开展研发工作；
---4.工作认真负责，有进取精神，具备良好的职业素养和敬业精神。`,
      },
//       electricalEngineer: {
//         title: "电气工程师",
//         details: `岗位职责：
// ---1、电气图纸设计；
// ---2、根据公司标准化进行电气硬件选型；
// ---3、跟进施工现场电气施工情况；
// ---4、现场安装调试电气设备，分析处理现场故障；
// ---5、PLC程序的编写与调试；
// ---6、负责共享文件之电气类资料的建立更新维护和备份；
// ---7、协助各专业及部门的各类验证工作；
// ---8、完成上级领导安排的其他工作。
// ---任职要求：
// ---1、全日制本科及以上学历，电气自动化相关专业；
// ---2、5年以上工业自动化、电气自动化线路设计和电子生产工艺经验；
// ---3、熟悉AutoCAD等电气设计相关的软件，精通PLC编程（三菱、西门子等）、熟练labview软件，熟悉各种人机界面设计；
// ---4、能独立承担电气项目的设计及调试工作；
// ---5、服从上级领导的安排，工作认真负责；
// ---6、具有良好的团队精神和较强的协调能力，良好的沟通能力。`,
//       },
//       purchasingEngineer: {
//         title: "采购工程师",
//         details: `岗位职责：
// ---1、负责机械加工件采购；
// ---2、负责机械加工成本分析，降低采购成本；
// ---3、开展供应商渠道开拓；
// ---4、做好采购物资质量问题中的各种影响因素及主要原因的分析；
// ---5、协助开展市场信息收集和研究；
// ---6、建立及维护优质供应商关系；
// ---7、做好供应商往来的跟单、建账和统计分析。
// ---任职要求：
// ---1、全日制大专及以上学历，采购专业、机械设计、数控机械加工专业为佳；
// ---2、机械加工及芯片行业企业任职经验优先；
// ---3、5-10年采购工作经验，5年以上机械加工件采购工作经验；
// ---4、具有较强的沟通协作能力、丰富的谈判技巧，熟练掌握经济法尤其是合同法等相关法律知识；
// ---5、熟练使用各类办公软件，包括ERP系统及OA办公自动化系统。`,
//       },
    },
  },
  info:{
    accordionTitle:"联系方式",
    menuTitle:"联系方式",
    content:`地址：上海市浦东新区康威路781号
    ---电话：---（总机） 021-50817399---（市场营销部） 021-64056173---（招聘） 021-50817399-8006
    ---邮箱 :
    ---（销售） sales{'@'}shsctec.com ---（招聘） hr{'@'}shsctec.com ---（咨询） inquiry{'@'}shsctec.com ---（反商业贿赂）inspection{'@'}shsctec.com`
  }
};
